module.exports = __webpack_public_path__ + "img/calin.cfa96e9d.png";